import React from "react";
import { usePatientMode } from "@/lib/patientMode";

const T = {
  fr: {
    title: (n) => (n ? `Merci ${n} d'avoir pris ce temps pour vous.` : "Merci d'avoir pris ce temps pour vous."),
    body:
      "Ces résultats ne sont pas un verdict, mais un point de départ pour la réflexion. Vous pourrez en reparler tranquillement avec votre praticien lors de votre prochaine séance. Pensez à exporter votre rapport en PDF pour le lui partager.",
  },
  es: {
    title: (n) => (n ? `Gracias ${n} por dedicarte este tiempo.` : "Gracias por dedicarte este tiempo."),
    body:
      "Estos resultados no son un veredicto, sino un punto de partida para la reflexión. Podrás comentarlos con calma con tu profesional en tu próxima sesión. No olvides exportar tu informe en PDF para compartirlo con él o ella.",
  },
};

export const PatientClosing = ({ lang = "fr" }) => {
  const { patientMode, patientName } = usePatientMode();
  if (!patientMode) return null;
  const t = T[lang] || T.fr;
  return (
    <div
      className="rounded-3xl bg-[var(--sand)] border border-[var(--border)] p-6 sm:p-8 mb-10 text-center print-break"
      data-testid="patient-closing"
    >
      <h3 className="font-serif-title text-2xl sm:text-3xl text-[var(--gold)] mb-3">{t.title(patientName)}</h3>
      <p className="text-[var(--ink)] leading-relaxed max-w-xl mx-auto">{t.body}</p>
    </div>
  );
};
